/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./putRecord.defs.js";
export { main as default } from "./putRecord.defs.js";
